export const MONTHLY_COMPLIANCE_STATUS_ORDER = ['CONFIRMED', 'TRANSIT', 'DELIVERED'] as const

export type MonthlyComplianceStatus = (typeof MONTHLY_COMPLIANCE_STATUS_ORDER)[number]

/** Collapse selection to a full prefix from CONFIRMED up to the highest tier chosen (sequential rule). */
export function normalizeMonthlyComplianceSelection(
  selected: readonly string[],
): MonthlyComplianceStatus[] {
  if (!selected.length) return []
  const indices = selected
    .map(v => MONTHLY_COMPLIANCE_STATUS_ORDER.indexOf(v as MonthlyComplianceStatus))
    .filter(i => i >= 0)
  if (!indices.length) return []
  const max = Math.max(...indices)
  return MONTHLY_COMPLIANCE_STATUS_ORDER.slice(0, max + 1) as MonthlyComplianceStatus[]
}
